import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AIVehicleFinder from '../components/AIVehicleFinder';
import AITradeInEstimator from '../components/AITradeInEstimator';
import AIFinanceAdvisor from '../components/AIFinanceAdvisor';
import AIServiceScheduler from '../components/AIServiceScheduler';
import InventoryShowcase from '../components/InventoryShowcase';
import ComparisonTool from '../components/ComparisonTool';
import VirtualShowroom from '../components/VirtualShowroom';
import AIContentAssistant from '../components/AIContentAssistant';
import CustomerStories from '../components/CustomerStories';
import ROIMetrics from '../components/ROIMetrics';
import Footer from '../components/Footer';
import AIChat from '../components/AIChat';
import LiveChatSupport from '../components/LiveChatSupport';
import VehicleWishlist from '../components/VehicleWishlist';
import PriceAlerts from '../components/PriceAlerts';

function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <HeroSection />
      <AIVehicleFinder />
      <InventoryShowcase />
      <ComparisonTool />
      <VirtualShowroom />
      <AITradeInEstimator />
      <AIFinanceAdvisor />
      <AIServiceScheduler />
      <AIContentAssistant />
      <CustomerStories />
      <ROIMetrics />
      <Footer />
      <AIChat />
      <LiveChatSupport />
      <VehicleWishlist />
      <PriceAlerts />
    </div>
  );
}

export default Home;